import { PdpState, PdpStore } from './store';

export const observeStore = <TReducer>(
    store: PdpStore<TReducer>,
    select: (state: PdpState<TReducer>) => any,
    onChange: (nextState: any, previousState: any) => void
) => {
    let currentState = select(store.getState());
    return store.subscribe(() => {
        const previousState = currentState;
        const newState = select(store.getState());
        if (newState !== previousState) {
            currentState = newState;
            onChange(newState, previousState);
        }
    });
};